/**
 * Specials section – Motion inView for card animation
 * Targets the section card (inner group) for fade-in on scroll
 */

import { inView, animate } from 'motion';

const init = () => {
  const section = document.querySelector('.wp-block-group.is-style-section-specials');
  if (!section) return;

  const card = section.querySelector(':scope > .wp-block-group');
  if (!card) return;

  inView(
    card,
    () => {
      animate(card, { opacity: 1, y: 0 }, { duration: 0.5, ease: 'easeOut' });
    },
    { once: true, amount: 0.2 }
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const card = document.querySelector('.wp-block-group.is-style-section-specials > .wp-block-group');
  if (card) {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
  }
  init();
});
